import styled from 'styled-components';

export const ProfileItem = styled.div`
  height: 5.25rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-radius: 2rem;
`;
